var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class StudentTypeService {
    static searchAll(search, max = 50, sort = "name") {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/studentTypes/search/findByNameLike", {
                params: { search, max, sort },
            });
            return response.data._embedded.studentTypes;
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/studentTypes/search/findByIdIn?ids=${ids.join(",")}`);
            return response.data._embedded.studentTypes;
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getPagedResponse("/aviso/StudentType/search", {
                query: search.query,
                active: search.active,
                ids: search.ids,
                codes: search.codes,
                studentTypeIds: search.studentTypeIds,
                srcSystemIds: search.srcSystemIds,
                names: search.names,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
        });
    }
}
